"use strict";
'app public';

// Helper to generate Vues computed methods for simple channel modes.
// Eg. +i, +n, etc
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function generateComputedMode(mode) {
  return {
    get() {
      return this.modeVal(mode);
    },
    set(newVal) {
      return this.setMode((newVal ? '+' : '-') + mode);
    }
  };
}

// Helper to generate Vues computed methods for channel modes with a parameter
// Eg. "+k key"
function generateComputedModeWithParam(mode) {
  return {
    get() {
      let val = this.modeVal(mode);
      return val === false ? '' : val;
    },
    set(newVal) {
      if (newVal) {
        this.setMode('+' + mode, newVal);
      } else {
        this.setMode('-' + mode, this.modeVal(mode));
      }
    }
  };
}
var _default = exports.default = {
  props: ['buffer'],
  data() {
    return {
      showPrevTopics: false
    };
  },
  computed: {
    modeM: generateComputedMode('m'),
    modeI: generateComputedMode('i'),
    modeS: generateComputedMode('s'),
    modeT: generateComputedMode('t'),
    modeN: generateComputedMode('n'),
    modeK: generateComputedModeWithParam('k'),
    topic: {
      get() {
        return this.buffer.topic;
      },
      set(newVal) {
        let newTopic = newVal.replace('\n', ' ');
        if (!newTopic.trim()) {
          this.buffer.getNetwork().ircClient.raw(`TOPIC ${this.buffer.name} :`);
        } else {
          this.buffer.getNetwork().ircClient.setTopic(this.buffer.name, newTopic);
        }
      }
    },
    prevTopics() {
      return this.buffer.topics.slice(1).filter(topic => topic.trim());
    },
    areWeAnOp() {
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    }
  },
  methods: {
    setMode(mode, param) {
      this.buffer.getNetwork().ircClient.raw('MODE', this.buffer.name, mode, param);
    },
    modeVal(mode) {
      let val = false;
      if (typeof this.buffer.modes[mode] === 'undefined') {
        // Specifically undefined = mode not set
        val = false;
      } else if (!this.buffer.modes[mode]) {
        // Falsy value = mode set without value
        val = true;
      } else {
        // Anything else = mode set with a value
        val = this.buffer.modes[mode];
      }
      return val;
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["ChannelInfo"]
window._app_exports.components.ChannelInfo = exports.default ? exports.default : exports;
